module.exports = __webpack_public_path__ + "media/D2 Plaza 7.1b837db5.mp3";